var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rental Property"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 11.798V21.798H7.5V16.798H9.5V21.798H15.5V11.798L8.5 6.79803L1.5 11.798ZM13.5 19.798H11.5V14.798H5.5V19.798H3.5V12.828L8.5 9.25803L13.5 12.828V19.798ZM17.5 7.79803H19.5V9.79803H17.5V7.79803ZM17.5 11.798H19.5V13.798H17.5V11.798ZM17.5 15.798H19.5V17.798H17.5V15.798Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5 11.798V21.798H7.5V16.798H9.5V21.798H15.5V11.798L8.5 6.79803L1.5 11.798Z",
    fill: "#14AA3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 3.79803V5.76803L12.5 7.19803V5.79803H21.5V19.798H17.5V21.798H23.5V3.79803H10.5Z",
    fill: "#6E6E6E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario11);
export default __webpack_public_path__ + "static/media/Scenario11.f8d5b65f561be5c94f89459f5a7a75bf.svg";
export { ForwardRef as ReactComponent };